import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StepsEffects } from './+state/steps.effects';
import { StepsFacade } from './+state/steps.facade';
import * as fromSteps from './+state/steps.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromSteps.SESSIONS_FEATURE_KEY, fromSteps.reducer),
    EffectsModule.forFeature([StepsEffects]),
  ],
  providers: [StepsFacade],
})
export class OnmatStoreStepsModule {}
